<div id="rp_one" class="liquid-form-area" [ngClass]="sucessClassAdd">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Reset Password</h4>
        <p>Please create a new password for your account</p>
    </div>
    <div class="liquid-form-content">
        <form [formGroup]="resetForm" (ngSubmit)="reset()">
            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <label for="r_password">New Password</label>
                <input
                    id="r_password"
                    type="password"
                    placeholder="Password (min 8 characters)"
                    formControlName="password"
                />
                <div
                    *ngIf="
                        resetForm.controls['password'].touched &&
                        !resetForm.controls['password'].valid
                    "
                >
                    <span
                        *ngIf="
                            resetForm.controls['password'].hasError('required')
                        "
                    >
                        Password is required
                    </span>
                    <span
                        *ngIf="
                            resetForm.controls['password'].hasError('minlength')
                        "
                    >
                        Password must be at minimum 8 characters
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->

            <!-- single liquid form  -->
            <div class="single-liquid-form">
                <label for="c_password">Confirm New Password</label>
                <input
                    id="c_password"
                    type="password"
                    placeholder="Confirm Password"
                    formControlName="confirm_password"
                />
                <div
                    *ngIf="
                        resetForm.controls['confirm_password'].touched &&
                        !resetForm.controls['confirm_password'].valid
                    "
                >
                    <span
                        *ngIf="
                            resetForm.controls['confirm_password'].hasError(
                                'required'
                            )
                        "
                    >
                        Confirm password is required
                    </span>
                    <span
                        *ngIf="
                            resetForm.controls['confirm_password'].hasError(
                                'minlength'
                            )
                        "
                    >
                        Confirm password must be at minimum 8 characters
                    </span>
                    <span
                        *ngIf="
                            resetForm.controls['confirm_password'].hasError(
                                'mustMatch'
                            )
                        "
                    >
                        Passwords do not match
                    </span>
                </div>
            </div>
            <!-- single liquid form  -->
            <div class="liquid-login-form-submit">
                <div id="fast-btn">
                    <button
                        type="submit"
                        [disabled]="resetForm.invalid || isLoader"
                    >
                        <i
                            class="fa fa-circle-o-notch fa-spin"
                            *ngIf="isLoader"
                        ></i>
                        Reset Password
                    </button>
                </div>
            </div>
        </form>
        <div class="error-message text-center">
            <p>{{ errorMsg }}</p>
        </div>
    </div>
</div>

<!-------------------------Sucess Section ----------------------------------->

<div id="rp_two" class="liquid-form-area tabcontent" [ngClass]="sucessClass">
    <div class="liquid-form-logo">
        <a href="#"><img src="assets/images/logo.png" alt="" /></a>
    </div>
    <div class="liquid-form-heading-text">
        <h4>Reset Password Successful!</h4>
        <p>Password successfully changed.</p>
    </div>
    <div class="signin-link-btn">
        <a routerLink="/auth/login">SIGN IN</a>
    </div>
</div>

<!-------------------------Sucess Section End ----------------------------------->
